import { createAction, props } from '@ngrx/store';
import { ClinicalReviewSubmittalStatus } from '../../review-queue/models/clinical-review-submittal-status.model';

//Gets new Submittal Statuses for clinical
export const loadClinicalSubmittalStatuses = createAction(
    '[CLINICAL REVIEW SEARCH ALL] Load Clinical Submittal Statuses'
);

export const loadClinicalSubmittalStatusesSuccess = createAction(
    '[CLINICAL REVIEW] Load Clinical Submittal Statuses Success',
    props<{
        clinicalSubmittalStatuses: ClinicalReviewSubmittalStatus[];
    }>()
);

export const loadClinicalSubmittalStatusesFailed = createAction(
    '[CLINICAL REVIEW] Load Clinical Submittal Statuses Failed',
    props<{
        error: string;
        exception: unknown;
    }>()
);
